import clsx from 'clsx';
import React from 'react';

import LogoTIProWithIconTI from '@components/Images/Rebranding/LogoTIProWithIconTI';
import { Theme } from '@interfaces/global';

import { CompanyLogo } from './Companies';
import Companies from './Companies';
import Projects from './Projects';

interface TheInformationProProps {
  className?: string;
  companyLogos?: CompanyLogo[];
  projectClassName?: string;
  theme?: Theme;
}

const TheInformationPro = ({
  className,
  companyLogos,
  projectClassName,
  theme = Theme.Dark,
}: TheInformationProProps) => {
  return (
    <div
      className={clsx(
        'mt-64 w-full bg-grayscale-charcoal px-16 py-48 sm:mt-96 sm:py-64',
        className,
        {
          'bg-transparent': theme === Theme.Light,
        }
      )}
    >
      <div className="m-auto flex max-w-[864px] flex-col items-center">
        <LogoTIProWithIconTI
          className="w-[215px] sm:w-[370px]"
          logoColor={theme === Theme.Dark ? 'white' : 'black'}
        />
        <p
          className={clsx('mb-0 mt-48 max-w-[710px] font-suisse-intl text-body-lg font-light', {
            'text-black': theme === Theme.Light,
            'text-white': theme === Theme.Dark,
          })}
        >
          <span className="font-bold text-pro-gold">The Information Pro</span> is a subscription
          that provides access to The Information’s proprietary data tools to augment our exclusive
          journalism. It’s the ultimate tool for professionals who want to stay ahead in today’s
          fast-paced, competitive business environment.
          <span className="mt-24 block">
            Get unlimited access to our exclusive journalism, proprietary databases, 60+ org charts,
            and more: everything you need to make business decisions with confidence.
          </span>
        </p>
        <Companies theme={theme} companiesLogo={companyLogos} />
        <Projects theme={theme} className={projectClassName} />
      </div>
    </div>
  );
};

export default TheInformationPro;
